﻿<template>
  <div class="booking-table-wrapper">
    <div class="booking-table">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th @click="setSort('trip')" class="sortable">
                <button type="button" class="expander-btn ml-1" @click.stop="Toggle_Names_All()" :aria-pressed="namesExpandedAll">
                  <span v-if="namesExpandedAll">[-]</span><span v-else>[+]</span>
                </button>
                Trip Name
                <span v-if="sortKey==='trip'">{{ sortAsc ? '▲' : '▼' }}</span>
              </th>
              <th @click="setSort('departure')" class="sortable">
                Departure Date <span v-if="sortKey==='departure'">{{ sortAsc ? '▲' : '▼' }}</span>
              </th>
              <th @click="setSort('id')" class="sortable">
                Booking ID <span v-if="sortKey==='id'">{{ sortAsc ? '▲' : '▼' }}</span>
              </th>
              <th @click="setSort('reference')" class="sortable">
                Agent Reference <span v-if="sortKey==='reference'">{{ sortAsc ? '▲' : '▼' }}</span>
              </th>
              <th @click="setSort('lead')" class="sortable">
                Lead Guest <span v-if="sortKey==='lead'">{{ sortAsc ? '▲' : '▼' }}</span>
              </th>
              <th @click="setSort('booking')" class="sortable">
                Booking Date <span v-if="sortKey==='booking'">{{ sortAsc ? '▲' : '▼' }}</span>
              </th>
              <th @click="setSort('consultant')" class="sortable">
                Consultant <span v-if="sortKey==='consultant'">{{ sortAsc ? '▲' : '▼' }}</span>
              </th>
              <th @click="setSort('status')" class="sortable">
                Status <span v-if="sortKey==='status'">{{ sortAsc ? '▲' : '▼' }}</span>
              </th>
                <th v-if="(bookings?.length ?? 0) > 0">View</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(b, idx) in Sorted_Bookings" :key="Row_Key(b, idx)" :class="{ even: !(idx % 2) }">
              <td class="trip-click" :title="namesExpandedAll ? 'Click to collapse' : Trip_Name(b)" @click="Toggle_Names_All()">
                {{ Display_Trip_Name(b) }}
              </td>
              <td>{{ Departure_Date_Display(b) }}</td>
              <td>{{ Booking_ID(b) }}</td>
              <td>{{ Agent_Reference(b) }}</td>
              <td>{{ Lead_Passenger(b) }}</td>
              <td>{{ Booking_Date_Display(b) }}</td>
              <td>{{ Get_Consultant(b) }}</td>
              <td>{{ Booking_Status(b) }}</td>
              <td class="text-center">
                <div class="cursor-pointer" @click="Booking_Details(b, idx)" :class="{ 'opacity-50 pointer-events-none': searching }">
                  <!-- spinning icon while loading -->
                  <svg v-if="idx === loadingIndex" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="external-link-alt" class="inline h-5 w-5 text-gray-500 animate-spin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path
                      fill="currentColor"
                      d="M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"
                    />
                  </svg>
                  <!-- normal icon -->
                  <svg v-else aria-hidden="true" focusable="false" data-prefix="fas" data-icon="external-link-alt" class="inline h-5 w-5 text-blue-600" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path
                      fill="currentColor"
                      d="M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"
                    />
                  </svg>
                </div>
              </td>
            </tr>
            <tr v-if="(bookings?.length ?? 0) === 0">
              <td colspan="8" class="text-center py-3">No bookings found.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script lang="ts" src="./booking_table.ts"></script>
